<template>
    <div>
        <div
            class="afu-mb-6"
            v-if="coverLetters.length"
        >
            <C1Button
                id="dzCoverLetter"
                :is-busy="loader.store_cover_letter"
                :disabled="$_seekerFieldByCode('cover_letters').read_only"
                variant="primary"
            >
                <FontAwesomeIcon
                    :icon="['far', 'plus']"
                    class="afu-mr-2"
                />

                {{ $t('label.upload_new_cover_letter') }}
            </C1Button>
        </div>
        <C1Alert
            v-if="response.message"
            :variant="response.status"
        >
            <span v-html="response.message" />
        </C1Alert>

        <div
            v-if="!coverLetters.length"
            class="af-no-result-found afu-text-black afu-text-sm afu-font-medium afu-text-center afu-mt-5 afu-p-7 afu-bg-white"
        >
            <div class="afu-text-neutral-dark afu-text-lg afu-mb-5 afu-flex afu-flex-col afu-gap-5 afu-justify-center afu-items-center">
                <svg
                    width="51"
                    height="50"
                    viewBox="0 0 51 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M25.5 0C11.6895 0 0.5 11.1895 0.5 25C0.5 38.8105 11.6895 50 25.5 50C39.3105 50 50.5 38.8105 50.5 25C50.5 11.1895 39.3105 0 25.5 0ZM25.5 45.1613C14.381 45.1613 5.33871 36.119 5.33871 25C5.33871 13.881 14.381 4.83871 25.5 4.83871C36.619 4.83871 45.6613 13.881 45.6613 25C45.6613 36.119 36.619 45.1613 25.5 45.1613ZM20.6613 20.1613C20.6613 18.377 19.2198 16.9355 17.4355 16.9355C15.6512 16.9355 14.2097 18.377 14.2097 20.1613C14.2097 21.9456 15.6512 23.3871 17.4355 23.3871C19.2198 23.3871 20.6613 21.9456 20.6613 20.1613ZM33.5645 16.9355C31.7802 16.9355 30.3387 18.377 30.3387 20.1613C30.3387 21.9456 31.7802 23.3871 33.5645 23.3871C35.3488 23.3871 36.7903 21.9456 36.7903 20.1613C36.7903 18.377 35.3488 16.9355 33.5645 16.9355ZM25.5 28.2258C21.9113 28.2258 16.5484 30.373 15.8427 34.3952C15.6411 35.5847 16.75 36.5625 17.9093 36.2198C21.0544 35.252 23.8972 34.6774 25.5 34.6774C27.1028 34.6774 29.9456 35.252 33.0907 36.2198C34.2399 36.5726 35.3589 35.5847 35.1573 34.3952C34.4516 30.373 29.0887 28.2258 25.5 28.2258Z"
                        fill="#E5E6E2"
                    />
                </svg>
                {{ $t('cover_letter.not_found') }}
            </div>
            <C1Button
                id="dzCoverLetter"
                :is-busy="loader.store_cover_letter"
                :disabled="$_seekerFieldByCode('cover_letters').read_only"
                variant="outline-secondary"
            >
                <FontAwesomeIcon
                    :icon="['far', 'plus']"
                    class="afu-mr-2"
                />

                {{ $t('label.upload_new_cover_letter') }}
            </C1Button>
        </div>

        <template v-else>
            <Card
                v-for="coverLetter in coverLetters"
                :key="coverLetter.id"
                class="afu-flex afu-flex-col md:afu-flex-row md:afu-items-center afu-justify-between"
            >
                <div>
                    <div class="afu-text-4xl afu-font-semibold afu-text-black afu-mb-2">
                        {{ coverLetter.filename }}
                    </div>

                    <div class="afu-text-sm afu-text-neutral-dark">
                        {{ $t('cover_letter.uploaded') }} {{ coverLetter.created_at }}
                    </div>
                </div>

                <div class="afu-mt-3 md:afu-mt-0">
                    <C1Button
                        variant="neutral"
                        @click="downloadCoverLetter(coverLetter)"
                    >
                        <FontAwesomeIcon
                            :icon="['fal', 'arrow-to-bottom']"
                            class="afu-mr-2"
                            fixed-width
                        />

                        {{ $t('label.download') }}
                    </C1Button>

                    <C1Button
                        variant="neutral"
                        class="afu-ml-2"
                        :disabled="$_seekerFieldByCode('cover_letters').read_only"
                        @click="onDestroy(coverLetter)"
                    >
                        <FontAwesomeIcon
                            :icon="['fal', 'trash-alt']"
                            class="afu-mr-2"
                            fixed-width
                        />

                        {{ $t('label.remove') }}
                    </C1Button>
                </div>
            </Card>
        </template>

        <CoverLetterModalDestroy
            :is-modal-open="isModalDestroyOpen"
            v-if="isModalDestroyOpen"
            :cover-letter="coverLetterToBeDestroyed"
            @close="isModalDestroyOpen = false"
            @closeModal="isModalDestroyOpen = false"
            @destroyed="onDestroyed"
        />
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import Dropzone from 'dropzone';
    import moment from 'moment/src/moment';
    import C1Button from '@/components/C1Components/C1Button';
    import Card from '@/apps/dashboard/001/components/Card/Card';
    import CoverLetterModalDestroy from '@/apps/dashboard/001/components/CoverLetters/CoverLetterModalDestroy';
    import C1Alert from '@/components/C1Components/C1Alert';

    export default {
        name: 'CoverLetters',

        filters: {
            dateFormat(value, format) {
                if (!value) {
                    return '';
                }
                return moment
                    .utc(value)
                    .local()
                    .format(format);
            },
        },

        components: {
            CoverLetterModalDestroy,
            Card,
            C1Button,
            C1Alert,
        },

        data() {
            return {
                coverLetters: [],
                coverLetterToBeDestroyed: {},
                isModalDestroyOpen: false,
                response: {
                    status: '',
                    message: '',
                },
                loader: {
                    store_cover_letter: false,
                    get_cover_letters: false,
                },
            };
        },

        created() {
            this.getCoverLetters();
        },

        mounted() {
            this.initDropzone();
        },

        computed: {
            ...mapGetters('site', {
                $_seekerFieldByCode: 'seekerFieldByCode',
            }),
        },

        methods: {
            ...mapActions('me', {
                $_storeCoverLetter: 'storeCoverLetter',
                $_getCoverLetters: 'getCoverLetters',
                $_disabledCoverLetters: 'disabledCoverLetters',
                $_downloadCoverLetter: 'downloadCoverLetter',
            }),

            initDropzone() {
                const vm = this;
                const el = this.$el.querySelector('#dzCoverLetter');

                this.dropzone = new Dropzone(el, {
                    url: '/',
                    maxFiles: 1,
                    addRemoveLinks: false,
                    uploadMultiple: false,
                    maxFilesize: 10,
                    autoProcessQueue: false,
                    acceptedFiles: '.pdf,.doc,.docx,.rtf,.txt',
                    createImageThumbnails: false,
                    error(file, msg) {
                        vm.response.status = 'danger';
                        vm.response.message = msg;
                        this.removeFile(file);
                    },
                    accept(file) {
                        vm.storeCoverLetter(file);
                        this.removeFile(file);
                    },
                    addedfile() {
                        vm.response.status = '';
                        vm.response.message = '';
                    },
                });
            },

            storeCoverLetter(file) {
                this.loader.store_cover_letter = true;
                this.$_storeCoverLetter(file)
                    .then(response => {
                        this.coverLetters.push(response);
                    })
                    .finally(() => {
                        this.loader.store_cover_letter = false;
                    });
            },

            getCoverLetters() {
                this.loader.get_cover_letters = true;
                this.$_getCoverLetters()
                    .then(response => {
                        this.coverLetters = response.data;
                    })
                    .finally(() => {
                        this.loader.get_cover_letters = false;
                    });
            },

            downloadCoverLetter(cover_letter) {
                this.$_downloadCoverLetter(cover_letter.uuid).then(response => {
                    if (navigator.userAgent.match('CriOS')) {
                        //Chrome iOS
                        var reader = new FileReader();
                        reader.onloadend = () => {
                            // window.open(reader.result);
                            const link = document.createElement('a');
                            link.href = reader.result;
                            link.setAttribute(
                                'download',
                                response.headers['resume-filename'],
                            );
                            document.body.appendChild(link);
                            link.click();
                            link.remove();
                        };
                        reader.readAsDataURL(new Blob([response.data]));
                    } else {
                        window.URL = window.URL || window.webkitURL;
                        const url = window.URL.createObjectURL(
                            new Blob([response.data]),
                        );
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute(
                            'download',
                            response.headers['resume-filename'],
                        );
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    }
                });
            },

            onDestroy(cover_letter) {
                this.coverLetterToBeDestroyed = cover_letter;
                this.openModalDestroy();
            },

            onDestroyed(uuid) {
                const index = this.coverLetters.findIndex(o => o.uuid === uuid);
                if (index >= 0) {
                    this.coverLetters.splice(index, 1);
                }
            },

            openModalDestroy() {
                this.isModalDestroyOpen = true;
            },

            closeModalDestroy() {
                this.coverLetterToBeDestroyed = {};
                this.isModalDestroyOpen = false;
            },
        },
    };
</script>
